import type { GlobalScope } from '@xing-com/crate-xinglet/internal';

export function register(
  globalScope: GlobalScope,
  dependency: string,
  value: Record<string, unknown> | (() => Promise<Record<string, unknown>>)
): void {
  (globalScope.crateImports ??= {})[dependency] =
    typeof value === 'function' ? () => value().then(toESM) : toESM(value);
}

function toESM<T extends Record<string, unknown>>(module: T): T {
  if (
    module.default &&
    typeof module.default === 'object' &&
    'default' in module.default &&
    module.default.default !== undefined
  ) {
    return { ...module, default: module.default.default };
  }

  return module;
}
